// extracted by mini-css-extract-plugin
module.exports = {"box":"article-module--box--Lywac"};